/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { SurveyRespondentCreateModel } from "../../models/survey-respondent-create-model";


export interface SurveyRespondentPutParams {
    body: SurveyRespondentCreateModel,
    surveyRespondentGuid: string,
}

export function surveyRespondentsPut(http: HttpClient, rootUrl: string, params: SurveyRespondentPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, surveyRespondentsPut.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('surveyRespondentGuid', params.surveyRespondentGuid, {"style":"simple"});

    rb.body(params.body, 'application/json');

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

surveyRespondentsPut.PATH = '/api/v1/survey-respondents/{surveyRespondentGuid}';
